import { ReactComponent as CheckIcon } from 'shared/assets/icons/check.svg'
import Button from 'shared/ui/Button_2'
import Flex from 'shared/ui/Flex'
import Text from 'shared/ui/Text'

import {
  Container,
  Image,
  SelectOverlay,
  SelectedContainer
} from './Style'

type TemplateItemProps = {
  name: string
  image: string
  isSelected: boolean
  onSelectTemplate: () => void
}

const TemplateItem: React.FC<TemplateItemProps> = ({
  name,
  image,
  isSelected,
  onSelectTemplate
}) => {
  return (
    <Container isSelected={isSelected}>
      <Image src={image}>
        {isSelected && (
          <SelectedContainer>
            <Flex direction="column" alignItems="center" rowGap={4}>
              <CheckIcon />
              <Text
                size={8}
                weight={600}
                id="Panel.switchCoverTemplate.template.selected"
                color="rgba(199, 210, 254, 1)"
              />
            </Flex>
          </SelectedContainer>
        )}

        <SelectOverlay>
          <Button
            size="md"
            textId="Switch"
            intent="secondary-base"
            onPress={onSelectTemplate}
          />
        </SelectOverlay>
      </Image>
      <Text size={14} weight={600} text={name} />
    </Container>
  )
}

export default TemplateItem
